import downloadCodesFields from '../../../fields/downloadCodesFields';
import RenderDateWithFromTime from '@/common-utils/components/renders/date/RenderDateWithFromTime';
import generateColumnDefByField from '@/common-utils/functions/generateColumnDefByField';
import DropdownDownloadCodeActionsRow from '../../dropdown/DropdownDownloadCodeActionsRow';
import ColumnSelection from '@/common-utils/components/renders/dataTable/column/ColumnSelection';

export const columnsDownloadCodesId = 'downloadCodes';

export const columnsDownloadCodes = (headerPackage) => {
    return ([
        // ColumnSelection
        headerPackage.selectionMode && ColumnSelection(columnsDownloadCodesId, headerPackage.singleSelection),
        // Columns
        generateColumnDefByField({
            field: downloadCodesFields.UUID,
            headerPackage: headerPackage,
            show: !headerPackage.selectionMode,
            customCellFn: ({ row }) => (
                row &&
                <DropdownDownloadCodeActionsRow downloadCode={row.original} />
            )
        }),
        generateColumnDefByField({
            field: downloadCodesFields.CREATED_AT,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(downloadCodesFields.CREATED_AT.key)} />
            )
        }),
        generateColumnDefByField({
            field: downloadCodesFields.DOWNLOAD_CODE_NAME,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: downloadCodesFields.SCHEDULED_START_DATE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(downloadCodesFields.SCHEDULED_START_DATE.key)} />
            )
        }),
        generateColumnDefByField({
            field: downloadCodesFields.SCHEDULED_END_DATE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(downloadCodesFields.SCHEDULED_END_DATE.key)} />
            )
        }),
        generateColumnDefByField({
            field: downloadCodesFields.ACCESS_CODE,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: downloadCodesFields.DOWNLOAD_SERVER_IP_ADDRESS_PORT,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: downloadCodesFields.CREATED_BY,
            headerPackage: headerPackage
        })
    ]).filter(col => !!col);
};